import { IElectionResult } from '@/shared/api-client/models/election-result';
import { Prop, Vue } from 'vue-property-decorator';

export default abstract class BaseElectionResultListComponent<T> extends Vue {

    @Prop() public electionId!: string;
    @Prop() public result!: IElectionResult<T>;
    @Prop() public translations!: { [key: string]: string; };

    public get hasBlankVotes(): boolean {

        if (!this.result) {
            return false;
        }

        if (this.result.blankVoteCount === undefined) {
            return false;
        }

        return this.result.blankVoteCount > 0;
    }
}